import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import Welcome from "../views/Welcome.vue";
import Auth from "../views/Auth.vue";
import Employees from "../views/Employees.vue";
import NewProject from "../views/NewProject.vue";
import NotFound from "../views/NotFound.vue";
import NewEmployee from "../views/NewEmployee.vue";
import Task from "../views/Task.vue";
import store from "../store/index.js";

const routes = [
  { path: "/", component: Welcome },
  { path: "/home", component: Home, meta: { requireAuth: true } },
  {
    path: "/task/:projectId",
    component: Task,
    props: true,
    meta: { requireAuth: true },
  },
  { path: "/auth", component: Auth, meta: { requirUnauth: true } },
  { path: "/employees", component: Employees, meta: { requireAuth: true } },
  { path: "/newEmployee", component: NewEmployee, meta: { requireAuth: true } },
  { path: "/newEmployee/:id", component: NewEmployee, props:true, meta: { requireAuth: true } },
  { path: "/newProject", component: NewProject, props:true, meta: { requireAuth: true } },
  { path: "/newProject/:id", component: NewProject, props:true, meta: { requireAuth: true } },
  { path: "/:notFount(.*)", component: NotFound },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(function(to, _, next) {
  if (to.meta.requireAuth && !store.getters["auth/isAuthenticated"]) {
    next("/auth");
  } else if (to.meta.requirUnauth && store.getters["auth/isAuthenticated"]) {
    next("/home");
  } else {
    next();
  }
});

export default router;
